import { render, staticRenderFns } from "./Accreditations.vue?vue&type=template&id=6ab75a34&scoped=true"
import script from "./Accreditations.vue?vue&type=script&lang=js"
export * from "./Accreditations.vue?vue&type=script&lang=js"
import style0 from "./Accreditations.vue?vue&type=style&index=0&id=6ab75a34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab75a34",
  null
  
)

export default component.exports